export class PurchasingGroupId {
    constructor(public readonly value: string) {}
}
